import { createSelector } from 'reselect'
import { capitalize } from 'lodash'
import { RootState } from '~store/root.reducer'

const selectAccountState = (state: RootState) => state.account

export const getAccountInfo = createSelector(
  selectAccountState,
  state => state.accountInfo,
)

export const getAccountInfoUserName = createSelector(
  getAccountInfo,
  // eslint-disable-next-line camelcase -- camelcase is provided by msal
  accountInfo => `${capitalize(accountInfo?.idTokenClaims?.given_name)} ${capitalize(accountInfo?.idTokenClaims?.family_name)}`,
)

export const getUserAsync = createSelector(
  selectAccountState,
  state => state.user,
)

export const getUser = createSelector(
  getUserAsync,
  userAsync => userAsync.payload,
)

export const getUserFinishedRegistrationForm = createSelector(
  getUser,
  user => !!user?.id,
)
